import ReactDom from 'react-dom';
import React from "react";
import {TgSubscribe} from "./TgSubscribe";

let elements = document.querySelectorAll('.tg-subscribe-react');
if (elements) {
    elements.forEach(el => {
        ReactDom.render(<TgSubscribe/>, el);
    });
}